export default __webpack_public_path__ + "static/media/facebook copy.c777a5cf.svg";